import { APARTMENT, LUXURY, BOUTIQUE, FAMILY, ADULTS_ONLY, CITY, ALL_INCLUSIVE, SUN_AND_BATH } from 'constants/themes';

export const themeIdsOrder = [APARTMENT, LUXURY, BOUTIQUE, ADULTS_ONLY, CITY, FAMILY, ALL_INCLUSIVE, SUN_AND_BATH];
